let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9w1d9")).then(() => parcelRequire('gbFt2'));